import ApiService from '../../utils/ApiService';
import Urls from '../../utils/Urls';
import * as Func from '../../utils/functions';
import {removeObjectNull} from "../../utils/functions";
import ExclusiveContentResponse, {ExclusiveContentLayoutResponse} from "../mapping/Response/ExclusiveContentResponse";

export function getListPost(params) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.EXCLUSIVE_CONTENT_POST_LIST,
        params: params,
        parser: dataParser,
    }).get();
}

export function getListLayout(params) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.EXCLUSIVE_CONTENT_LAYOUT_LIST,
        params: params,
        parser: data => new ExclusiveContentLayoutResponse(data.data.result).exportList(),
    }).get();
}

export function createPost(data) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.EXCLUSIVE_CONTENT_POST_CREATE,
    }).post(data);
}

export function updatePost(data) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.EXCLUSIVE_CONTENT_POST_UPDATE,
        endpointParams: {id: data?.id},
    }).put(data);
}

export function updateLayout(data) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.EXCLUSIVE_CONTENT_LAYOUT_UPDATE,
        // endpointParams: {id: data?.id},
    }).put(data);
}

export function getItemPost(id) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.EXCLUSIVE_CONTENT_POST_GET_ITEM,
        endpointParams: {id},
        parser: data => new ExclusiveContentResponse(data.data.result).exportItem(),
    }).get();
}

function dataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new ExclusiveContentResponse(item).exportList()),
        total_page: Math.ceil(parseInt(data.data.total) / parseInt(data.data.page_size))
    }
}
